import _URL from '../../URL/index';
const axios = _URL.axios;
const limit = 10

export default {
    services: {
        getServiveces: (branch, token) => {
            return axios(token).post(`/dispatch/services`, { branch: branch })
        },
        getQuote: (body, token) => {
            return axios(token).post(`/dispatch-quotation`, body)
        },
        getDestinations: (body, token) => {
            return axios(token).post(`/dispatch/quote/destination`, body)
        },
        getVehiclesByBranch: (_id, token) => {
            if (_id !== null && _id !== "") {
                return axios(token).get(`/dispatch/branches/${_id}/vehicles`)
            } else {
                return axios(token).get(`/dispatch/branches/vehicles`)
            }
        }
    }
}